import type { ReactNode } from "react";
import { RevealOnScroll } from "./RevealOnScroll";

export type Engagement = { label: string; title: string; body: ReactNode };

export function EngagementGrid({ items }: { items: Engagement[] }) {
  return (
    <RevealOnScroll>
      <div className="grid gap-px overflow-hidden rounded-lg border border-rule bg-rule md:grid-cols-2">
        {items.map((e) => (
          <div key={e.label} className="bg-white p-7">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-cyan-deep">
              {e.label}
            </div>
            <div className="mt-3 font-display text-xl text-ink">{e.title}</div>
            <p className="mt-3 text-sm leading-relaxed text-ink-3">{e.body}</p>
          </div>
        ))}
      </div>
    </RevealOnScroll>
  );
}
